import React from "react";

import { faPencil } from "@fortawesome/pro-solid-svg-icons";
import { faEye } from "@fortawesome/free-solid-svg-icons";

import { ACTION_COLUMN_NAME } from "constants/aggrid";
import { MultiButton, SlimButton } from "components/Button";

import { ColDef, ICellRendererParams } from "ag-grid-community";
import { useDispatch } from "react-redux";
import { openDispatchingModal } from "actions";
import { getReturnTo } from "lib/navigation";
import { ModalTypes } from "constants/navigation";
import { hasPermission } from "lib/permissions";
import { BusinessLabelPermissions } from "constants/permissions";
import { BusinessLabelArchetypeLabels } from "constants/businessLabel";

export const BusinessLabelColId = {
  NAME: "3a4f8d12-1b2c-4e5f-8a9b-0c1d2e3f4a5b",
  ARCHETYPE: "5b6c7d8e-9f0a-4b1c-2d3e-4f5a6b7c8d9e",
  ACTIONS: "7e8f9a0b-1c2d-4e5f-6a7b-8c9d0e1f2a3b",
} as const;

const ActionRenderer = ({ data }: ICellRendererParams) => {
  const dispatch = useDispatch();

  if (!data) {
    return null;
  }

  const { id } = data || {};

  function onClickEdit() {
    dispatch(
      openDispatchingModal(ModalTypes.BusinessLabel, getReturnTo(), { id }),
    );
  }

  const readOnly = !hasPermission(data, BusinessLabelPermissions.update);

  const buttons = [
    {
      dataTour: "editBusinessLabel",
      default: false,
      icon: readOnly ? faEye : faPencil,
      isDisabled: false,
      onClick: onClickEdit,
      title: readOnly ? "View" : "Edit",
      tooltip: `${readOnly ? "View" : "Edit"} the Business Label`,
    },
  ];

  return <MultiButton buttons={buttons} ButtonComponent={SlimButton} />;
};

const archetypeValueGetter = ({ data }: { data: BusinessLabel }) =>
  data?.archetype
    ? BusinessLabelArchetypeLabels[data.archetype] ?? data.archetype
    : null;

export const BusinessLabelColumnDef: Record<string, ColDef<BusinessLabel>> = {
  [BusinessLabelColId.NAME]: {
    colId: BusinessLabelColId.NAME,
    headerName: "Name",
    field: "name",
  },
  [BusinessLabelColId.ARCHETYPE]: {
    colId: BusinessLabelColId.ARCHETYPE,
    headerName: "Base",
    field: "archetype",
    valueGetter: archetypeValueGetter,
    enableRowGroup: true,
  },
  [BusinessLabelColId.ACTIONS]: {
    colId: BusinessLabelColId.ACTIONS,
    headerName: ACTION_COLUMN_NAME,
    pinned: "right",
    cellRenderer: ActionRenderer,
    width: 100,
  },
};
